export default __webpack_public_path__ + "static/media/04_Finance_and_Accounting_Guidelines.d67d0d10.pdf";